import { render } from "./LayoutsVideo.vue?vue&type=template&id=ab3c0c3a&scoped=true&ts=true&lang=pug"
import script from "./LayoutsVideo.vue?vue&type=script&lang=ts"
export * from "./LayoutsVideo.vue?vue&type=script&lang=ts"

import "./LayoutsVideo.vue?vue&type=style&index=0&id=ab3c0c3a&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3c0c3a"]])

export default __exports__